var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"id":"error-modal","close-button-label":"Ok","title":"Erro ao processar operação"}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }